"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const clsx_1 = __importDefault(require("clsx"));
const Box_1 = __importDefault(require("../../../../layouts/Box"));
const useStyles = core_1.makeStyles((theme) => ({
    root: {
        '&:hover': {
            color: theme.palette.grey[900],
        },
    },
    rootContainer: {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[900],
        '& .MuiAccordionSummary-content': {
            padding: '10px 16px',
            margin: 0,
        },
    },
    header: {
        fontSize: '14px',
    },
    headerContainer: {
        fontWeight: 700,
    },
}));
const ExpansionPanelSummary = ({ variant, expanded, header, description, }) => {
    const styles = useStyles();
    const isContainer = variant === 'container';
    return (react_1.default.createElement(core_1.AccordionSummary, { className: clsx_1.default({
            [styles.rootContainer]: isContainer,
            [styles.root]: !isContainer,
        }) },
        react_1.default.createElement(Box_1.default, { width: "100%" },
            react_1.default.createElement(Box_1.default, { display: "flex", alignItems: "center" },
                expanded ? react_1.default.createElement(icons_1.ExpandLess, { transform: "rotate(180)" }) : react_1.default.createElement(icons_1.ExpandMore, { transform: "rotate(-90)" }),
                typeof header === 'string' ? (react_1.default.createElement(core_1.Typography, { className: clsx_1.default({ [styles.header]: !isContainer }, { [styles.headerContainer]: isContainer }), variant: "h3" }, header)) : (header)),
            react_1.default.createElement(Box_1.default, { pl: 2.4 }, description && typeof description === 'string' ? (react_1.default.createElement(core_1.Typography, { variant: "body2", component: "span" }, description)) : (description)))));
};
exports.default = react_1.memo(ExpansionPanelSummary);
//# sourceMappingURL=index.js.map